const authFr = {
    "sign_in": "Se connecter",
    "email": "Adresse email",
    "password": "Mot de passe",
    "sign_in_button": "Se connecter",
    "invalid_credentials": "Identifiants invalides",
    "password_min_length": "Le mot de passe doit comporter au moins 8 caractères.",
    "passwords_do_not_match": "Les mots de passe ne correspondent pas.",
    "invalid_token": "Jeton invalide",
    "password_set": "Définition du mot de passe",
    "confirm_password": "Confirmez le mot de passe",
    "confirm_title": "Confirmation d'inscription de l'administrateur Quickpick",
    "confirm_text": "Pour créer votre compte, il vous suffit de fournir un mot de passe sécurisé",
    "set_password": "Définir le mot de passe",
    "account_activated": "Compte activé",
    "account_activated_text": "Vous pouvez désormais vous connecter à votre compte utilisateur avec l'adresse e-mail et le mot de passe que vous avez fournis.",
    "continue_to_login": "Continuer la connexion",
    "forgotten_password": "Mot de passe oublié",
    "unable_to_reset_password": "Erreur interne, impossible de réinitialiser le mot de passe.",
    "reset_password_title": "Réinitialiser le mot de passe",
    "reset_password_text": "Veuillez saisir l'adresse e-mail associée à votre compte. Nous vous enverrons le lien de réinitialisation du mot de passe à cette adresse.",
    "send_reset_mail": "Envoyer le lien de réinitialisation du mot de passe",
    "send_reset_mail_success": "Un courriel contenant des instructions supplémentaires a été envoyé à l'adresse indiquée.",
    "invalid_email": "Adresse e-mail invalide",
    "reset_sent": "Courriel envoyé",
    "change_password_title": "Changer le mot de passe",
    "change_password_success": "Mot de passe modifié avec succès",
    "roles": {
        "OWNER": "Administrateur",
        "MENU_EDITOR": "Édition de menu",
        "STAFF_MANAGER": "Gestion du personnel"
    },
    "name": "Nom",
    "permissions": "Autorisations",
    "create_user_permissions": "Créer des autorisations utilisateur",
    "add_restaurant": "Ajouter un restaurant",
    "user_saved": "Utilisateur enregistré",
    "has_admin_permissions": "Autorisations d'administrateur",
    "login_with_google": "Se connecter avec Google",
    "missing_perrmissions": "Vous ne disposez pas des autorisations requises pour accéder à cette page.",
    "qp_signup_title": "Inscription QuickPick",
    "qp_signup_text": "Remplissez les champs ci-dessous pour créer un compte utilisateur !",
    "user_information": "Informations utilisateur",
    "restaurant_information": "Informations sur les restaurants",
    "restaurant_shortname": "Identifiant du restaurant",
    "restaurant_name": "Nom du restaurant",
    "create_profile": "Créer",
    "restaurant_name_short": "Le nom du restaurant doit comporter au moins 3 caractères.",
    "identifier_example": "Exemple d'identificateur",
    "invalid_shortname": "L'identifiant du restaurant doit comporter au moins 3 caractères.",
    "restaurant_shortname_already_in_use": "Identifiant du restaurant déjà utilisé",
    "name_missing": "Le nom est manquant",
    "signup_failed": "L'inscription a échoué. Veuillez réessayer plus tard.",
    "no_restaurant_title": "Aucun restaurant sélectionné pour votre compte",
    "no_restaurant_text": "Si vous venez de créer votre compte, vous devriez également enregistrer votre restaurant !",
    "no_restaurant_alt": "Si vous deviez avoir accès à un restaurant, veuillez contacter l'administrateur du restaurant.",
    "no_user_created_yet": "Vous n'avez pas encore de compte ?",
    "signup_success": "Inscription réussie",
    "grant_admin_title": "Accorder les autorisations d'administrateur",
    "grant_admin_confirmation": "Un utilisateur disposant des droits d'administrateur peut gérer les paramètres du restaurant, ajouter et supprimer des utilisateurs, gérer les abonnements, les paiements et les factures. La modification du menu ne requiert pas de droits d'administrateur.",
    "selected_user": "Utilisateur sélectionné",
    "delete_user_title": "Supprimer l'utilisateur",
    "delete_user_confirmation": "L'utilisateur sélectionné sera retiré du restaurant et n'aura plus accès à son menu. Cette action est irréversible.",
    "admin": "Administrateur",
    "activate_account": "Activer le compte",
    "account_pending_activation": "Votre compte utilisateur est en attente d'activation.",
    "check_your_activate_email": "Veuillez consulter votre boîte de réception et cliquer sur le lien d'activation.",
    "refresh_page": "Actualiser la page",
    "did_not_receive_activation_email": "Je n'ai pas reçu l'e-mail d'activation",
    "activate_tip": "Si vous ne trouvez pas l'e-mail d'activation, vérifiez également votre dossier de courriers indésirables. S'il n'y est toujours pas, cliquez sur le bouton ci-dessous pour le renvoyer.",
    "resend_email": "Renvoyer",
    "email_resent": "L'e-mail d'activation a été renvoyé avec succès. Veuillez consulter votre boîte de réception.",
    "accept_terms_and_conditions": "J'ai lu et j'accepte les <a>Conditions générales et la politique de confidentialité</a>",
    "complete_registration": "Inscription complète",
    "auth_in_progress": "Authentification en cours...",
    "account_successfully_activated": "Votre compte QuickPick a été activé avec succès.",
    "continue_to_home_page": "Retour à la page d'accueil",
    "invalid_activation": "Une erreur s'est produite lors de l'activation de votre compte. Veuillez réessayer plus tard ou contacter notre service client.",
    "activation_mail_sent": "Nous avons commencé la création de votre compte. Veuillez consulter votre boîte de réception et finaliser votre inscription en cliquant sur le lien contenu dans l'e-mail."
};

export default authFr;
